import { render } from "./scatterPlot.vue?vue&type=template&id=2547b00f&scoped=true"
import script from "./scatterPlot.vue?vue&type=script&lang=js"
export * from "./scatterPlot.vue?vue&type=script&lang=js"

import "./scatterPlot.vue?vue&type=style&index=0&id=2547b00f&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2547b00f"]])

export default __exports__